const PlayerIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5C12.7909 5 11 6.79086 11 9C11 11.2091 12.7909 13 15 13Z"
      fill="#AFB1BA"
    />
    <path
      d="M11.0001 15.25C8.90904 15.25 7.149 16.8151 6.90469 18.8918L6.25521 24.4124C6.20681 24.8237 6.50106 25.1965 6.91244 25.2449C7.32382 25.2933 7.69654 24.999 7.74494 24.5876L8.39441 19.0671C8.51949 18.0039 9.26894 17.1515 10.2501 16.859L10.2501 21.052C10.25 21.9505 10.25 22.6997 10.33 23.2945C10.4144 23.9223 10.6001 24.4891 11.0555 24.9445C11.511 25.4 12.0778 25.5857 12.7056 25.6701C13.3004 25.7501 14.0496 25.75 14.948 25.75H15.0521C15.9505 25.75 16.6998 25.7501 17.2946 25.6701C17.9223 25.5857 18.4891 25.4 18.9446 24.9445C19.4001 24.4891 19.5858 23.9223 19.6702 23.2945C19.7501 22.6997 19.7501 21.9505 19.7501 21.052L19.7501 16.859C20.7312 17.1515 21.4807 18.0039 21.6057 19.0671L22.2552 24.5876C22.3036 24.999 22.6763 25.2933 23.0877 25.2449C23.4991 25.1965 23.7933 24.8237 23.7449 24.4124L23.0955 18.8918C22.8511 16.8151 21.0911 15.25 19.0001 15.25H11.0001Z"
      fill="#AFB1BA"
    />
  </svg>
);

export default PlayerIcon;
